import { createApi } from '@reduxjs/toolkit/dist/query/react';

import { baseQuery, getBaseQueryWithReauth } from 'redux/baseQueryAuth';
import { type SupportOrder, type SupportOrdersParams, type SupportOrdersResponse } from '../types/SupportTypes';

const clean = (params: SupportOrdersParams) =>
  Object.fromEntries(Object.entries(params).filter(([, value]) => value !== undefined && value !== ''));

export const SupportApi = createApi({
  reducerPath: 'SupportApi',
  tagTypes: ['SupportOrders'],
  baseQuery: getBaseQueryWithReauth(baseQuery),
  endpoints: (build) => ({
    // "trader" | "merchant" | "admin" | "unknown" — the support desk is shown to "admin" only
    getUserType: build.query<string, void>({
      query: () => ({ url: '/users/get_user_type/', method: 'GET' }),
    }),
    getSupportOrders: build.query<SupportOrdersResponse, SupportOrdersParams>({
      query: (params) => ({ url: '/support/orders/', method: 'GET', params: clean(params) }),
      providesTags: [{ type: 'SupportOrders', id: 'LIST' }],
    }),
    openSupportDispute: build.mutation<SupportOrder, { id: string; body: FormData }>({
      query: ({ id, body }) => ({ url: `/support/orders/${id}/dispute/`, method: 'POST', body }),
      invalidatesTags: [{ type: 'SupportOrders', id: 'LIST' }],
    }),
    resolveSupportDispute: build.mutation<SupportOrder, { id: string; decision: 'approve' | 'reject' }>({
      query: ({ id, decision }) => ({ url: `/support/orders/${id}/resolve/`, method: 'POST', body: { decision } }),
      invalidatesTags: [{ type: 'SupportOrders', id: 'LIST' }],
    }),
  }),
});

export const {
  useGetUserTypeQuery,
  useGetSupportOrdersQuery,
  useOpenSupportDisputeMutation,
  useResolveSupportDisputeMutation,
} = SupportApi;
